<div
  #flavorColumn
  class="product-column-general product-flavor"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | method: 'getSectionBorderMarginSize'">
  <app-column-list-items
    [colVm]="colVm"
    [rowVm]="rowVm"
    [displayFormat]="displayFormat"
    [sectionColumnType]="colVm.columnType"
    [columnListLayoutModifierClass]="columnListLayoutModifierClass"
    [parentColumnElement]="flavorColumn">
  </app-column-list-items>
</div>
